export default function FeatureCard({ icon, title, description }) {
    return (
      <div className="bg-zinc-800/50 backdrop-blur-sm rounded-lg p-6 border border-zinc-700 hover:border-red-500/50 transition-all duration-300 hover:shadow-[0_0_15px_rgba(239,68,68,0.15)] group">
        <div className="mb-4">{icon}</div>
        <h3 className="text-xl font-bold mb-2 group-hover:text-red-500 transition-colors">{title}</h3>
        <p className="text-zinc-400">{description}</p>
      </div>
    )
  }
  
  